export default __webpack_public_path__ + "static/media/feature-tool_tab_4.0d249fdfb376e22b13acf6db46961d8e.svg";